import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';
import TabletopItem from '../item/tabletopItem';
import GroupItem from '../item/groupItem';
import TabletopGroupItem from '../item/tabletopGroupItem';

/**
 * Group items command
 *
 * @class GroupItemsCommand
 * @extends AbstractCommand
 */
export default class GroupItemsCommand extends AbstractCommand {
    /**
     * @param {ItemCollection} itemCollection
     * @param {SelectionCollection} selection
     * @param {AbstractItem[]} items
     */
    constructor(itemCollection, selection, items) {
        super();
        if (!Array.isArray(items) || items.length <= 1) {
            throw new Error('Only one item is selected.');
        }

        const parentItem = items[0].getParentItem();

        this.itemCollection = itemCollection;
        this.selection = selection;
        this.items = items;

        this.groupItem = (parentItem instanceof TabletopItem)
            ? new TabletopGroupItem({}, {}, parentItem)
            : new GroupItem({}, {}, parentItem);
    }

    /**
     * Execute command
     */
    execute() {
        this.selection.clear();

        this.groupItem.clearItems();
        this.itemCollection.remove(this.items);
        this.groupItem.addItems(this.items);
        this.itemCollection.add(this.groupItem);

        this.selection.selectItem(this.groupItem, true);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.selection.clear();

        this.groupItem.clearItems();
        this.itemCollection.remove(this.groupItem);
        this.itemCollection.add(this.items);

        this.selection.selectItems(this.items, true);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return 'Group items';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.GroupItemsCommand = GroupItemsCommand;
